export const CHECKOUT_URL =
  'https://menopausia.impultienda.ar/checkout/menopausia'

export const PRICE = 'USD $15'

export const IMAGES = {
  mockup: 'https://cdn.magicpatterns.com/uploads/vBPMrjK2c8ydw3unc8pRJX/Menopausia-2.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/mXp7VKsgjf3skT8pQbCpzT/BONO_1_MENOPAUSIA.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/92NuDmd4jwkzsxuZMgMgDJ/BONO_2_MENOPAUSIA.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/v7DAg9PFFjdoEf7GTLcbAe/BONO_3_MENOPAUSIA.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/dhy7GLddkLgvdWNksqSduM/BONO_4_MENOPAUSIA.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/76HmtMSEH5hiJpnLrXAxvS/BONO_5_MENOPAUSIA.png',
}

export const stats = [
  { value: '+300', label: 'Algoritmos clínicos listos para usar' },
  { value: '+2.000', label: 'Médicos ya utilizan el sistema' },
  { value: '+1.500', label: 'Horas ahorradas al año consultando guías' },
  { value: '99%', label: 'Se sienten más seguros al prescribir' },
]

export const societies = ['NAMS', 'IMS', 'EMAS', 'ACOG']

export const beforeAfter = [
  {
    before: 'Consultas largas y desordenadas',
    after: 'Un sistema estructurado que guía cada consulta',
  },
  {
    before: 'Dudas sobre cuándo indicar Terapia Hormonal',
    after: 'Algoritmos claros para decidir en minutos',
  },
  {
    before: 'Temor a equivocarte por riesgos o contraindicaciones',
    after: 'Estratificación clínica basada en evidencia',
  },
  {
    before: 'Horas revisando distintas guías internacionales',
    after: 'Una sola Ruta Clínica con todo integrado',
  },
  {
    before: 'Respuestas poco convincentes ante preguntas difíciles',
    after: 'Scripts clínicos respaldados por riesgo absoluto y relativo',
  },
  {
    before: 'Seguimiento basado en experiencia personal',
    after: 'Protocolos estandarizados para controlar la evolución',
  },
]

export const situations = [
  {
    emoji: '😰',
    text: 'Una paciente con sofocos incapacitantes llega a tu consulta y dudas si realmente es candidata a Terapia Hormonal.',
  },
  {
    emoji: '⏱️',
    text: 'Pierdes demasiado tiempo revisando diferentes guías antes de sentirte seguro para prescribir.',
  },
  {
    emoji: '🤷',
    text: 'No tienes claro si un antecedente familiar de cáncer de mama cambia completamente tu conducta clínica.',
  },
  {
    emoji: '💸',
    text: 'Terminas utilizando prácticamente el mismo esquema terapéutico porque no sabes cuándo individualizar el tratamiento.',
  },
  {
    emoji: '😓',
    text: 'Una paciente te pregunta si la Terapia Hormonal aumenta el riesgo de trombosis o cáncer y no logras transmitir la seguridad que quisieras.',
  },
  {
    emoji: '😩',
    text: 'Cada nueva paciente en perimenopausia se siente como empezar desde cero.',
  },
]

export const realities = [
  'No deberías sentir que estás improvisando.',
  'No deberías depender de revisar cientos de páginas antes de cada decisión.',
  'No deberías salir de una consulta preguntándote si elegiste el tratamiento correcto.',
]

export const tomos = [
  {
    n: 'I',
    title: 'El Punto de Partida',
    lead: 'Identifica desde la primera consulta si una paciente realmente es candidata a Terapia Hormonal.',
    text: 'Olvídate de las dudas diagnósticas. Diferencia perimenopausia, menopausia y otras causas de los síntomas con una ruta clínica clara, lógica y basada en evidencia.',
    bullets: [
      'Historia clínica enfocada',
      'Diagnóstico diferencial',
      'Ventana de oportunidad',
      'Laboratorios realmente necesarios',
      'Algoritmos diagnósticos',
      'Casos clínicos',
    ],
  },
  {
    n: 'II',
    title: 'Prescribe con Confianza',
    lead: 'Reduce el riesgo antes de prescribir y decide con el respaldo de la evidencia.',
    text: 'Estratifica el riesgo cardiovascular, trombótico y oncológico mediante algoritmos que convierten las principales guías internacionales en decisiones simples.',
    bullets: [
      'Riesgo cardiovascular',
      'Riesgo tromboembólico',
      'Riesgo de cáncer de mama',
      'Contraindicaciones',
      'Selección de candidatas',
      'Algoritmos de seguridad',
    ],
  },
  {
    n: 'III',
    title: 'La Fórmula del Tratamiento Ideal',
    lead: 'Descubre exactamente qué tratamiento elegir para cada paciente.',
    text: 'Qué hormona utilizar. Qué vía elegir. Qué dosis iniciar. Cómo individualizar el tratamiento. Todo organizado para que nunca tengas que improvisar.',
    bullets: ['Qué hormona', 'Qué vía', 'Qué dosis', 'Cómo individualizar'],
  },
  {
    n: 'IV',
    title: 'Optimiza Cada Resultado',
    lead: 'Aprende cuándo ajustar, cuándo cambiar y cuándo mantener la terapia.',
    text: 'Iniciar el tratamiento solo es el primer paso. Aquí aprenderás cómo conseguir resultados sostenibles y pacientes satisfechas.',
    bullets: ['Ajustes de dosis', 'Cambios de esquema', 'Efectos secundarios', 'Seguimiento'],
  },
  {
    n: 'V',
    title: 'Resuelve los Casos Más Difíciles',
    lead: 'Incluso cuando la Terapia Hormonal no parece una opción, sabrás cómo actuar.',
    text: 'Pacientes complejas. Contraindicaciones. Enfermedades asociadas. Alternativas no hormonales. Todo explicado paso a paso.',
    bullets: [
      'Pacientes complejas',
      'Contraindicaciones',
      'Patologías asociadas',
      'Alternativas no hormonales',
    ],
  },
  {
    n: 'VI',
    title: 'Consulta Lista para Aplicar',
    lead: 'Todo lo que necesitas para utilizar la Ruta Clínica desde el primer día.',
    text: 'Consentimientos, checklists, plantillas, historias clínicas, protocolos y scripts de comunicación listos para usar durante la consulta.',
    bullets: ['Consentimientos', 'Checklists', 'Plantillas', 'Protocolos', 'Scripts'],
  },
]

export const bonos = [
  {
    n: 1,
    title: 'Vademécum Inteligente de Terapia Hormonal',
    lead: 'Nunca vuelvas a preguntarte qué dosis o qué presentación utilizar.',
    text: 'Encuentra en segundos equivalencias, dosis habituales y comparaciones entre moléculas para prescribir con mayor rapidez y seguridad.',
    value: 'USD $15',
    image: IMAGES.bono1,
  },
  {
    n: 2,
    title: 'Laboratorios sin Complicaciones',
    lead: 'Interpreta FSH, Estradiol, LH y otros estudios con la seguridad de un especialista.',
    text: 'Aprende cuándo un laboratorio realmente cambia tu conducta clínica y cuándo no.',
    value: 'USD $25',
    image: IMAGES.bono2,
  },
  {
    n: 3,
    title: 'Scripts Médicos para Resolver las Objeciones Más Difíciles',
    lead: 'Nunca más te quedarás sin palabras ante preguntas sobre cáncer o trombosis.',
    text: 'Conversaciones estructuradas para transmitir confianza, aumentar la adherencia y fortalecer tu autoridad profesional.',
    value: 'USD $29',
    image: IMAGES.bono3,
  },
  {
    n: 4,
    title: 'Algoritmos para Resolver las Complicaciones Más Frecuentes',
    lead: 'Ten siempre una respuesta clara cuando el tratamiento no evolucione como esperabas.',
    text: 'Diagramas de decisión para sangrado uterino, efectos secundarios, cambios de dosis, suspensión del tratamiento y mucho más.',
    value: 'USD $35',
    image: IMAGES.bono4,
  },
  {
    n: 5,
    title: 'Kit Profesional para una Consulta Médica Segura',
    lead: 'Documenta cada consulta como un profesional y protege tu práctica clínica.',
    text: 'Consentimientos informados · Historia clínica especializada · Checklist pretratamiento · Checklist de seguimiento · Formatos de evolución · Registro de riesgos y beneficios.',
    value: 'USD $39',
    image: IMAGES.bono5,
  },
]

export const valueRows = [
  { label: 'Ruta Clínica de Menopausia™ (6 Tomos)', value: 'USD $197' },
  { label: 'Vademécum Inteligente', value: 'USD $15' },
  { label: 'Laboratorios sin Complicaciones', value: 'USD $25' },
  { label: 'Scripts Médicos', value: 'USD $29' },
  { label: 'Algoritmos Clínicos Avanzados', value: 'USD $35' },
  { label: 'Kit Profesional de Consulta', value: 'USD $39' },
]

export const includes = [
  'Los 6 Tomos de la Ruta Clínica de Menopausia™',
  'Más de 300 algoritmos, tablas y rutas de decisión',
  'Casos clínicos resueltos',
  'Protocolos listos para aplicar',
  'Herramientas de consulta',
  'Los 5 bonos exclusivos',
]

export const testimonials = [
  {
    quote:
      'Antes evitaba indicar Terapia Hormonal porque siempre tenía dudas. Ahora sigo la Ruta Clínica y cada decisión tiene una lógica clara. Mi consulta cambió por completo.',
    name: 'Dra. María P.',
    role: 'Ginecóloga · Colombia 🇨🇴',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/408ed459-59a4-4a7a-9e3b-e7a620f23444.jpg',
  },
  {
    quote:
      'Solo los algoritmos de estratificación de riesgo justifican el precio. Es una herramienta que utilizo prácticamente todos los días.',
    name: 'Dr. Rodrigo V.',
    role: 'Internista · México 🇲🇽',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/68fd4a63-4035-47ab-8d1a-d2adcb3ff684.jpg',
  },
  {
    quote:
      'El bono de Scripts Médicos cambió la forma en que hablo con mis pacientes. Hoy respondo preguntas difíciles con mucha más seguridad.',
    name: 'Dra. Andrea L.',
    role: 'Ginecóloga · Argentina 🇦🇷',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c462ea00-b0a4-42b7-bcd4-5d2bef4f9ed6.jpg',
  },
  {
    quote:
      'Pensé que estaba comprando un ebook. En realidad compré un sistema completo para tomar mejores decisiones clínicas.',
    name: 'Dra. Juliana M.',
    role: 'Médica General · Venezuela 🇻🇪',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d5a92b1d-4f6a-49bf-b9f9-2056a6236496.jpg',
  },
]

export const faqs = [
  {
    q: '¿El acceso es inmediato?',
    a: 'Sí. Una vez confirmado el pago, recibirás acceso instantáneo a todo el material digital.',
  },
  {
    q: '¿Funciona para médicos de cualquier país?',
    a: 'Sí. Está basado en guías internacionales y es aplicable en cualquier país de habla hispana.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagas una sola vez y el acceso es de por vida.',
  },
  {
    q: '¿Está actualizado?',
    a: 'Sí. El contenido está elaborado con base en las recomendaciones y la evidencia científica más reciente.',
  },
  {
    q: '¿En qué moneda pago?',
    a: 'El cambio de moneda es automático. El checkout detecta tu país y muestra el equivalente en tu moneda local sin que hagas nada.',
  },
]

export const buyers = [
  { name: 'Dra. Camila R.', city: 'Bogotá, Colombia' },
  { name: 'Dr. Andrés M.', city: 'Guadalajara, México' },
  { name: 'Dra. Lucía F.', city: 'Córdoba, Argentina' },
  { name: 'Dr. Javier S.', city: 'Lima, Perú' },
  { name: 'Dra. Valentina T.', city: 'Santiago, Chile' },
  { name: 'Dra. Paola G.', city: 'Quito, Ecuador' },
  { name: 'Dr. Sebastián O.', city: 'Montevideo, Uruguay' },
  { name: 'Dra. Mariana C.', city: 'Caracas, Venezuela' },
  { name: 'Dra. Elena V.', city: 'Madrid, España' },
  { name: 'Dr. Ricardo L.', city: 'San José, Costa Rica' },
  { name: 'Dra. Sofía B.', city: 'Asunción, Paraguay' },
  { name: 'Dr. Manuel A.', city: 'Panamá, Panamá' },
]
